import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DashboardPage from "./components/DashboardPage";

const Dashboard = () => {
  return (
    <>
      <div>
        <Sidebar />
      </div>

      <MainSection>
        <SectionHeader title="Dashboard" />
        <DashboardPage />
      </MainSection>
    </>
  );
};

export default Dashboard;
